import { apiKey } from '../../../utils/lightbox_helpers';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const COMPLETED_MAGIC_ID = '1001';
const VERIFIED_MAGIC_ID = '1003';
const NON_FAVORITE_IDS = [COMPLETED_MAGIC_ID, VERIFIED_MAGIC_ID];
const LIST_CONTENT_TYPES = ['trail', 'track', 'map'];

const getContentTypeNumber = (type, list) => {
  if (!Object.prototype.hasOwnProperty.call(list, type)) {
    return 0;
  }

  return Object.keys(list[type]).length;
};

const compileListContentsString = (listId, listItems) => {
  let num;
  const contents = [];

  LIST_CONTENT_TYPES.forEach(type => {
    num = getContentTypeNumber(type, listItems[listId]);

    if (num > 1) {
      const typeMultiple = StringConstantsMixin.strings.LIST_MODAL.TYPE_MULTIPLE[type.toUpperCase()];
      contents.push(`${num} ${typeMultiple}`);
    } else if (num === 1) {
      const typeSingle = StringConstantsMixin.strings.LIST_MODAL.TYPE_SINGLE[type.toUpperCase()];
      contents.push(`${num} ${typeSingle}`);
    }
  });

  return contents.join(' · ');
};

const getListImageUrl = listId => {
  return `/api/alltrails/lists/${listId}/profile_photo?key=${apiKey}&size=medium_square`;
};

const getFavoriteListIds = (listItems = {}) => {
  // gets a list of ids that are neither the COMPLETED_MAGIC_ID || VERIFIED_MAGIC_ID
  return Object.keys(listItems).filter(id => !NON_FAVORITE_IDS.includes(id));
};

const getFavoriteListsArray = lists => {
  return lists.filter(({ id }) => !NON_FAVORITE_IDS.includes(id)).sort((a, b) => b.order - a.order);
};

const isItemInList = (type, id, list) => {
  if (!Object.prototype.hasOwnProperty.call(list, type)) {
    return false;
  }

  return Object.prototype.hasOwnProperty.call(list[type], id);
};

const getItemInList = (type, id, list) => {
  if (!isItemInList(type, id, list)) {
    return null;
  }

  return list[type][id];
};

const isFavorite = (type, id, listItems = null) => {
  if (!listItems) {
    return false;
  }

  const listIds = getFavoriteListIds(listItems);
  return listIds.some(listId => isItemInList(type, id, listItems[listId]));
};

const isComplete = (type, id, listItems) => {
  if (!listItems || !Object.prototype.hasOwnProperty.call(listItems, COMPLETED_MAGIC_ID)) {
    return false;
  }

  return isItemInList(type, id, listItems[COMPLETED_MAGIC_ID]);
};

const isVerified = (type, id, listItems) => {
  if (!listItems || !Object.prototype.hasOwnProperty.call(listItems, VERIFIED_MAGIC_ID)) {
    return false;
  }

  return isItemInList(type, id, listItems[VERIFIED_MAGIC_ID]);
};

export {
  isFavorite,
  getFavoriteListIds,
  isComplete,
  isVerified,
  getFavoriteListsArray,
  getListImageUrl,
  compileListContentsString,
  isItemInList,
  getItemInList
};
